import { stats } from "@/content/stats";
import { useTranslation } from "react-i18next";

const UserMap = () => {
  const { t, i18n } = useTranslation();

  // Format users count with abbreviation based on language
  const isChinese = i18n.language.indexOf("zh") !== -1;
  const formattedUsers = isChinese
    ? Math.floor(stats.users / 10000) + ' 萬+'
    : Math.floor(stats.users / 1000) + 'k+';

  return (
    <section className="py-6 md:py-8 bg-slate-50">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-40 md:pb-48">
        <div className="text-center mb-3 md:mb-2 max-w-2xl mx-auto">
          <h2 className="text-3xl mx-8 md:mx-0 md:text-4xl font-semibold text-slate-900 mb-6">
            {t('map.title')}
          </h2>
          <p className="text-left text-slate-600 leading-relaxed text-base md:text-lg mx-2">
            {t('map.description')}
          </p>
        </div>

        <div className="relative -mx-4 sm:-mx-6 lg:-mx-8">
          {/* Main Map Image */}
          <div className="relative w-full z-0">
            <img
              src="https://cdn-site.clarymind.com/product-page-app/map/map.png"
              alt="User Map"
              className="w-full h-auto object-contain z-0"
            />
          </div>
        </div>

        {/* Stats Grid Overlayed or positioned below for mobile */}
        <div className="-mt-16 md:-mt-28 -mx-4 sm:-mx-6 lg:-mx-8 w-full absolute h-52 md:h-64 bg-gradient-to-t from-slate-50 from-[0%] via-slate-50/80 via-[85%] to-transparent to-[100%]">
          <div className="w-full z-10 grid grid-cols-2 md:grid-cols-2 gap-x-2 md:gap-x-0 gap-y-8 md:gap-8 md:mt-0 pointer-events-none px-8 sm:px-6 lg:px-8 ">
            <div className="flex flex-col items-center pointer-events-auto">
              <span className="text-5xl md:text-7xl font-semibold text-red-500 mb-2">
                {formattedUsers}
              </span>
              <span className="text-base md:text-lg text-slate-400">
                {t('map.users')}
              </span>
            </div>

            <div className="flex flex-col items-center pointer-events-auto">
              <span className="text-5xl md:text-7xl font-semibold text-sky-500 mb-2">
                {stats.rating.average}
              </span>
              <span className="text-base md:text-lg text-slate-400">
                {t('map.rating')}
              </span>
            </div>

            <div className="flex flex-col items-center pointer-events-auto">
              <span className="text-5xl md:text-7xl font-semibold text-sky-500 mb-2">
                100+
              </span>
              <span className="text-base md:text-lg text-slate-400">
                {t('map.countries')}
              </span>
            </div>

            <div className="flex flex-col items-center pointer-events-auto">
              <span className="text-5xl md:text-7xl font-semibold text-sky-500 mb-2">
                {stats.rating.count.toLocaleString()}
              </span>
              <span className="text-base md:text-lg text-slate-400">
                {t('map.ratingCount')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserMap;
